import WorkInProgressState from "Components/organisms/work-in-progress"
import { Container, Breadcrumb } from "reactstrap"

const FinanceDashboardTemplate = () => {
    return <div className="page-content">
        <Container fluid style={{ backgroundColor: 'var(--bs-body-bg)', padding: '10px' }}>
            <Breadcrumb
                title="Finance"
                breadcrumbItem="Dashboard"
            />
            <WorkInProgressState
                title={"Work in progress"}
                subtitle={"This page is still under construction. Come back another time!"}
            />

        </Container>
    </div>
}

export default FinanceDashboardTemplate